import {createSlice} from '@reduxjs/toolkit';
import type {PayloadAction} from '@reduxjs/toolkit';
import type {PremiumUpsellData, PremiumUpsellPanelState} from './premium-upsell-panel.types';
import {getPremiumUpsellData} from './premium-upsell-panel-thunk';

const initialState: PremiumUpsellPanelState = {
  data: null,
  isLoading: false,
  hasFailed: false,
};

export const premiumUpsellPanelSlice = createSlice({
  name: 'premiumUpsellPanel',
  initialState,
  reducers: {
    resetPremiumUpsellPanel: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPremiumUpsellData.pending, (state) => {
      state.isLoading = true;
      state.hasFailed = false;
    });
    builder.addCase(getPremiumUpsellData.fulfilled, (state, {payload}: PayloadAction<PremiumUpsellData>) => {
      state.data = payload;
      state.isLoading = false;
    });
    builder.addCase(getPremiumUpsellData.rejected, (state) => {
      state.isLoading = false;
      state.hasFailed = true;
    });
  },
});

export const {resetPremiumUpsellPanel} = premiumUpsellPanelSlice.actions;
export const premiumUpsellPanelReducer = premiumUpsellPanelSlice.reducer;
